import React, { useContext, useState, useEffect } from 'react';
import { Grid, Flexbox, Divider } from '@sede-enterprise/shell-ds-react-framework';
import 'leaflet/dist/leaflet.css';
import CiTradesChart from './CiTradeCharts/CiTradeBarChart/CiTradesChart';
import CiTradesTable from './CiTradeCharts/CiTradeTable/CiTradesTable';
import CiTradesHeader from './CiTradeHeader/CiTradeHeader';
import { CiTradeFilterSection } from './CiTradeFilterSection';
import DateSideCard from '../AnalyticsHome/DateSideCard/DateSideCard';
import PipelineRunMessageOverlay from '../PipelineRunMessage/PipelineRunMessageOverlay';
import { AppContext } from '../../../../Context/AppContext';

export const CiTrades = () => {
const { state: analyticsState, dispatch: analyticsDispatch } =
      useContext(AppContext).analyticsHome;
  const [isCiTradeChartApiResponseEmpty, setIsCiTradeChartApiResponseEmpty] = useState(false);
  const [isCiTradeTableApiResponseEmpty, setIsCiTradeTableApiResponseEmpty] = useState(false);
  
  useEffect(() => {
    analyticsDispatch({
      type: 'setIsAnyPrimaryApiResponseEmpty',
      payload: isCiTradeChartApiResponseEmpty ?? isCiTradeTableApiResponseEmpty,
    });
  }, [analyticsDispatch, isCiTradeChartApiResponseEmpty, isCiTradeTableApiResponseEmpty]);
  return (
    <div style={{ height: '100%', background: '#F5F5F5' }} data-testid='ci-trades'>
      <Flexbox gap='24px 24px' style={{ marginLeft: '15px', justifyContent: 'start' }}>
        <CiTradeFilterSection />
        <Grid gap='10px'>
          <Grid.Cell>
            <Flexbox justifyContent='space-between'>
              <CiTradesHeader />
              <DateSideCard />
            </Flexbox>
          </Grid.Cell>
          <Divider size='medium' direction='horizontal' />
          <Grid.Cell>
            <div style={{ position: 'relative' }}>
              <PipelineRunMessageOverlay show={analyticsState.isAnyPrimaryApiResponseEmpty} />
              <div>
                <CiTradesChart setIsCiTradeChartApiResponseEmpty={setIsCiTradeChartApiResponseEmpty} />
              </div>
              <div style={{ marginTop: '10px' }}>
                <CiTradesTable setIsCiTradeTableApiResponseEmpty={setIsCiTradeTableApiResponseEmpty} />
              </div>
            </div>
          </Grid.Cell>
        </Grid>
      </Flexbox>
    </div>
  );
};